export const countryCodesdata = [
	{
		code: 'AD',
		label: 'Andorra',
		phone: '376',
		pattern: /^[0-9]{6,9}$/,
		example: '123456',
		maxLength: 9,
	},
	{
		code: 'AE',
		label: 'United Arab Emirates',
		phone: '971',
		pattern: /^[0-9]{9}$/,
		example: '501234567',
		maxLength: 9,
	},
	{
		code: 'AF',
		label: 'Afghanistan',
		phone: '93',
		pattern: /^[0-9]{9}$/,
		example: '701234567',
		maxLength: 9,
	},
	{
		code: 'AG',
		label: 'Antigua and Barbuda',
		phone: '1-268',
		pattern: /^[0-9]{7}$/,
		example: '4641234',
		maxLength: 7,
	},
	{
		code: 'AI',
		label: 'Anguilla',
		phone: '1-264',
		pattern: /^[0-9]{7}$/,
		example: '2351234',
		maxLength: 7,
	},
	{
		code: 'AL',
		label: 'Albania',
		phone: '355',
		pattern: /^[0-9]{9}$/,
		example: '661234567',
		maxLength: 9,
	},
	{
		code: 'AM',
		label: 'Armenia',
		phone: '374',
		pattern: /^[0-9]{8}$/,
		example: '91123456',
		maxLength: 8,
	},
	{
		code: 'AO',
		label: 'Angola',
		phone: '244',
		pattern: /^[0-9]{9}$/,
		example: '912345678',
		maxLength: 9,
	},
	{
		code: 'AQ',
		label: 'Antarctica',
		phone: '672',
		pattern: /^[0-9]{6}$/,
		example: '123456',
		maxLength: 6,
	},
	{
		code: 'AR',
		label: 'Argentina',
		phone: '54',
		pattern: /^[0-9]{10}$/,
		example: '91112345678',
		maxLength: 10,
	},
	{
		code: 'AS',
		label: 'American Samoa',
		phone: '1-684',
		pattern: /^[0-9]{7}$/,
		example: '2581234',
		maxLength: 7,
	},
	{
		code: 'AT',
		label: 'Austria',
		phone: '43',
		pattern: /^[0-9]{10}$/,
		example: '6641234567',
		maxLength: 10,
	},
	{
		code: 'AU',
		label: 'Australia',
		phone: '61',
		pattern: /^[0-9]{9}$/,
		example: '412345678',
		maxLength: 9,
	},
	{
		code: 'AW',
		label: 'Aruba',
		phone: '297',
		pattern: /^[0-9]{7}$/,
		example: '5601234',
		maxLength: 7,
	},
	{
		code: 'AX',
		label: 'Åland Islands',
		phone: '358',
		pattern: /^[0-9]{10}$/,
		example: '4571234567',
		maxLength: 10,
	},
	{
		code: 'AZ',
		label: 'Azerbaijan',
		phone: '994',
		pattern: /^[0-9]{9}$/,
		example: '501234567',
		maxLength: 9,
	},
	{
		code: 'BA',
		label: 'Bosnia and Herzegovina',
		phone: '387',
		pattern: /^[0-9]{8}$/,
		example: '61123456',
		maxLength: 8,
	},
	{
		code: 'BB',
		label: 'Barbados',
		phone: '1-246',
		pattern: /^[0-9]{7}$/,
		example: '2341234',
		maxLength: 7,
	},
	{
		code: 'BD',
		label: 'Bangladesh',
		phone: '880',
		pattern: /^[0-9]{10}$/,
		example: '1712345678',
		maxLength: 10,
	},
	{
		code: 'BE',
		label: 'Belgium',
		phone: '32',
		pattern: /^[0-9]{9}$/,
		example: '470123456',
		maxLength: 9,
	},
	{
		code: 'BF',
		label: 'Burkina Faso',
		phone: '226',
		pattern: /^[0-9]{8}$/,
		example: '70123456',
		maxLength: 8,
	},
	{
		code: 'BG',
		label: 'Bulgaria',
		phone: '359',
		pattern: /^[0-9]{9}$/,
		example: '888123456',
		maxLength: 9,
	},
	{
		code: 'BH',
		label: 'Bahrain',
		phone: '973',
		pattern: /^[0-9]{8}$/,
		example: '36012345',
		maxLength: 8,
	},
	{
		code: 'BI',
		label: 'Burundi',
		phone: '257',
		pattern: /^[0-9]{8}$/,
		example: '79123456',
		maxLength: 8,
	},
	{
		code: 'BJ',
		label: 'Benin',
		phone: '229',
		pattern: /^[0-9]{8}$/,
		example: '90123456',
		maxLength: 8,
	},
	{
		code: 'BL',
		label: 'Saint Barthélemy',
		phone: '590',
		pattern: /^[0-9]{9}$/,
		example: '690123456',
		maxLength: 9,
	},
	{
		code: 'BM',
		label: 'Bermuda',
		phone: '1-441',
		pattern: /^[0-9]{7}$/,
		example: '3331234',
		maxLength: 7,
	},
	{
		code: 'BN',
		label: 'Brunei',
		phone: '673',
		pattern: /^[0-9]{7}$/,
		example: '8712345',
		maxLength: 7,
	},
	{
		code: 'BO',
		label: 'Bolivia',
		phone: '591',
		pattern: /^[0-9]{8}$/,
		example: '71234567',
		maxLength: 8,
	},
	{
		code: 'BQ',
		label: 'Caribbean Netherlands',
		phone: '599',
		pattern: /^[0-9]{7}$/,
		example: '3181234',
		maxLength: 7,
	},
	{
		code: 'BR',
		label: 'Brazil',
		phone: '55',
		pattern: /^[0-9]{10,11}$/,
		example: '11912345678',
		maxLength: 11,
	},
	{
		code: 'BS',
		label: 'Bahamas',
		phone: '1-242',
		pattern: /^[0-9]{7}$/,
		example: '3591234',
		maxLength: 7,
	},
	{
		code: 'BT',
		label: 'Bhutan',
		phone: '975',
		pattern: /^[0-9]{8}$/,
		example: '17123456',
		maxLength: 8,
	},
	{
		code: 'BW',
		label: 'Botswana',
		phone: '267',
		pattern: /^[0-9]{8}$/,
		example: '71123456',
		maxLength: 8,
	},
	{
		code: 'BY',
		label: 'Belarus',
		phone: '375',
		pattern: /^[0-9]{9}$/,
		example: '291234567',
		maxLength: 9,
	},
	{
		code: 'BZ',
		label: 'Belize',
		phone: '501',
		pattern: /^[0-9]{7}$/,
		example: '6011234',
		maxLength: 7,
	},
	{
		code: 'CA',
		label: 'Canada',
		phone: '1',
		pattern: /^[0-9]{10}$/,
		example: '4161234567',
		maxLength: 10,
	},
	{
		code: 'CC',
		label: 'Cocos (Keeling) Islands',
		phone: '61',
		pattern: /^[0-9]{9}$/,
		example: '412345678',
		maxLength: 9,
	},
	{
		code: 'CD',
		label: 'Democratic Republic of the Congo',
		phone: '243',
		pattern: /^[0-9]{9}$/,
		example: '991234567',
		maxLength: 9,
	},
	{
		code: 'CF',
		label: 'Central African Republic',
		phone: '236',
		pattern: /^[0-9]{8}$/,
		example: '70123456',
		maxLength: 8,
	},
	{
		code: 'CG',
		label: 'Republic of the Congo',
		phone: '242',
		pattern: /^[0-9]{9}$/,
		example: '061234567',
		maxLength: 9,
	},
	{
		code: 'CH',
		label: 'Switzerland',
		phone: '41',
		pattern: /^[0-9]{9}$/,
		example: '791234567',
		maxLength: 9,
	},
	{
		code: 'CI',
		label: 'Ivory Coast',
		phone: '225',
		pattern: /^[0-9]{10}$/,
		example: '0123456789',
		maxLength: 10,
	},
	{
		code: 'CK',
		label: 'Cook Islands',
		phone: '682',
		pattern: /^[0-9]{5}$/,
		example: '71234',
		maxLength: 5,
	},
	{
		code: 'CL',
		label: 'Chile',
		phone: '56',
		pattern: /^[0-9]{9}$/,
		example: '912345678',
		maxLength: 9,
	},
	{
		code: 'CM',
		label: 'Cameroon',
		phone: '237',
		pattern: /^[0-9]{9}$/,
		example: '671234567',
		maxLength: 9,
	},
	{
		code: 'CN',
		label: 'China',
		phone: '86',
		pattern: /^[0-9]{11}$/,
		example: '13123456789',
		maxLength: 11,
	},
	{
		code: 'CO',
		label: 'Colombia',
		phone: '57',
		pattern: /^[0-9]{10}$/,
		example: '3101234567',
		maxLength: 10,
	},
	{
		code: 'CR',
		label: 'Costa Rica',
		phone: '506',
		pattern: /^[0-9]{8}$/,
		example: '83123456',
		maxLength: 8,
	},
	{
		code: 'CU',
		label: 'Cuba',
		phone: '53',
		pattern: /^[0-9]{8}$/,
		example: '51234567',
		maxLength: 8,
	},
	{
		code: 'CV',
		label: 'Cape Verde',
		phone: '238',
		pattern: /^[0-9]{7}$/,
		example: '9911234',
		maxLength: 7,
	},
	{
		code: 'CW',
		label: 'Curaçao',
		phone: '599',
		pattern: /^[0-9]{7}$/,
		example: '95181234',
		maxLength: 7,
	},
	{
		code: 'CX',
		label: 'Christmas Island',
		phone: '61',
		pattern: /^[0-9]{9}$/,
		example: '412345678',
		maxLength: 9,
	},
	{
		code: 'CY',
		label: 'Cyprus',
		phone: '357',
		pattern: /^[0-9]{8}$/,
		example: '96123456',
		maxLength: 8,
	},
	{
		code: 'CZ',
		label: 'Czech Republic',
		phone: '420',
		pattern: /^[0-9]{9}$/,
		example: '721123456',
		maxLength: 9,
	},
	{
		code: 'DE',
		label: 'Germany',
		phone: '49',
		pattern: /^[0-9]{10}$/,
		example: '15123456789',
		maxLength: 10,
	},
	{
		code: 'DJ',
		label: 'Djibouti',
		phone: '253',
		pattern: /^[0-9]{8}$/,
		example: '77123456',
		maxLength: 8,
	},
	{
		code: 'DK',
		label: 'Denmark',
		phone: '45',
		pattern: /^[0-9]{8}$/,
		example: '20123456',
		maxLength: 8,
	},
	{
		code: 'DM',
		label: 'Dominica',
		phone: '1-767',
		pattern: /^[0-9]{7}$/,
		example: '2851234',
		maxLength: 7,
	},
	{
		code: 'DO',
		label: 'Dominican Republic',
		phone: '1',
		pattern: /^[0-9]{10}$/,
		example: '8091234567',
		maxLength: 10,
	},
	{
		code: 'DZ',
		label: 'Algeria',
		phone: '213',
		pattern: /^[0-9]{9}$/,
		example: '551234567',
		maxLength: 9,
	},
	{
		code: 'EC',
		label: 'Ecuador',
		phone: '593',
		pattern: /^[0-9]{9}$/,
		example: '991234567',
		maxLength: 9,
	},
	{
		code: 'EE',
		label: 'Estonia',
		phone: '372',
		pattern: /^[0-9]{8}$/,
		example: '53123456',
		maxLength: 8,
	},
	{
		code: 'EG',
		label: 'Egypt',
		phone: '20',
		pattern: /^[0-9]{10}$/,
		example: '1001234567',
		maxLength: 10,
	},
	{
		code: 'EH',
		label: 'Western Sahara',
		phone: '212',
		pattern: /^[0-9]{9}$/,
		example: '650123456',
		maxLength: 9,
	},
	{
		code: 'ER',
		label: 'Eritrea',
		phone: '291',
		pattern: /^[0-9]{7}$/,
		example: '7123456',
		maxLength: 7,
	},
	{
		code: 'ES',
		label: 'Spain',
		phone: '34',
		pattern: /^[0-9]{9}$/,
		example: '612345678',
		maxLength: 9,
	},
	{
		code: 'ET',
		label: 'Ethiopia',
		phone: '251',
		pattern: /^[0-9]{9}$/,
		example: '911234567',
		maxLength: 9,
	},
	{
		code: 'FI',
		label: 'Finland',
		phone: '358',
		pattern: /^[0-9]{10}$/,
		example: '401234567',
		maxLength: 10,
	},
	{
		code: 'FJ',
		label: 'Fiji',
		phone: '679',
		pattern: /^[0-9]{7}$/,
		example: '7012345',
		maxLength: 7,
	},
	{
		code: 'FK',
		label: 'Falkland Islands',
		phone: '500',
		pattern: /^[0-9]{5}$/,
		example: '61234',
		maxLength: 5,
	},
	{
		code: 'FM',
		label: 'Micronesia',
		phone: '691',
		pattern: /^[0-9]{7}$/,
		example: '3501234',
		maxLength: 7,
	},
	{
		code: 'FO',
		label: 'Faroe Islands',
		phone: '298',
		pattern: /^[0-9]{6}$/,
		example: '211234',
		maxLength: 6,
	},
	{
		code: 'FR',
		label: 'France',
		phone: '33',
		pattern: /^[0-9]{9}$/,
		example: '612345678',
		maxLength: 9,
	},
	{
		code: 'GA',
		label: 'Gabon',
		phone: '241',
		pattern: /^[0-9]{7}$/,
		example: '0601234',
		maxLength: 7,
	},
	{
		code: 'GB',
		label: 'United Kingdom',
		phone: '44',
		pattern: /^[0-9]{10}$/,
		example: '7912345678',
		maxLength: 10,
	},
	{
		code: 'GD',
		label: 'Grenada',
		phone: '1-473',
		pattern: /^[0-9]{7}$/,
		example: '4031234',
		maxLength: 7,
	},
	{
		code: 'GE',
		label: 'Georgia',
		phone: '995',
		pattern: /^[0-9]{9}$/,
		example: '591234567',
		maxLength: 9,
	},
	{
		code: 'GF',
		label: 'French Guiana',
		phone: '594',
		pattern: /^[0-9]{9}$/,
		example: '694201234',
		maxLength: 9,
	},
	{
		code: 'GG',
		label: 'Guernsey',
		phone: '44',
		pattern: /^[0-9]{10}$/,
		example: '7781123456',
		maxLength: 10,
	},
	{
		code: 'GH',
		label: 'Ghana',
		phone: '233',
		pattern: /^[0-9]{9}$/,
		example: '241234567',
		maxLength: 9,
	},
	{
		code: 'GI',
		label: 'Gibraltar',
		phone: '350',
		pattern: /^[0-9]{8}$/,
		example: '57123456',
		maxLength: 8,
	},
	{
		code: 'GL',
		label: 'Greenland',
		phone: '299',
		pattern: /^[0-9]{6}$/,
		example: '221234',
		maxLength: 6,
	},
	{
		code: 'GM',
		label: 'Gambia',
		phone: '220',
		pattern: /^[0-9]{7}$/,
		example: '3012345',
		maxLength: 7,
	},
	{
		code: 'GN',
		label: 'Guinea',
		phone: '224',
		pattern: /^[0-9]{9}$/,
		example: '601234567',
		maxLength: 9,
	},
	{
		code: 'GP',
		label: 'Guadeloupe',
		phone: '590',
		pattern: /^[0-9]{9}$/,
		example: '690123456',
		maxLength: 9,
	},
	{
		code: 'GQ',
		label: 'Equatorial Guinea',
		phone: '240',
		pattern: /^[0-9]{9}$/,
		example: '222123456',
		maxLength: 9,
	},
	{
		code: 'GR',
		label: 'Greece',
		phone: '30',
		pattern: /^[0-9]{10}$/,
		example: '6912345678',
		maxLength: 10,
	},
	{
		code: 'GT',
		label: 'Guatemala',
		phone: '502',
		pattern: /^[0-9]{8}$/,
		example: '51234567',
		maxLength: 8,
	},
	{
		code: 'GU',
		label: 'Guam',
		phone: '1-671',
		pattern: /^[0-9]{7}$/,
		example: '3001234',
		maxLength: 7,
	},
	{
		code: 'GW',
		label: 'Guinea-Bissau',
		phone: '245',
		pattern: /^[0-9]{7}$/,
		example: '95512345',
		maxLength: 7,
	},
	{
		code: 'GY',
		label: 'Guyana',
		phone: '592',
		pattern: /^[0-9]{7}$/,
		example: '6091234',
		maxLength: 7,
	},
	{
		code: 'HK',
		label: 'Hong Kong',
		phone: '852',
		pattern: /^[0-9]{8}$/,
		example: '51234567',
		maxLength: 8,
	},
	{
		code: 'HN',
		label: 'Honduras',
		phone: '504',
		pattern: /^[0-9]{8}$/,
		example: '91234567',
		maxLength: 8,
	},
	{
		code: 'HR',
		label: 'Croatia',
		phone: '385',
		pattern: /^[0-9]{9}$/,
		example: '911234567',
		maxLength: 9,
	},
	{
		code: 'HT',
		label: 'Haiti',
		phone: '509',
		pattern: /^[0-9]{8}$/,
		example: '34123456',
		maxLength: 8,
	},
	{
		code: 'HU',
		label: 'Hungary',
		phone: '36',
		pattern: /^[0-9]{9}$/,
		example: '201234567',
		maxLength: 9,
	},
	{
		code: 'ID',
		label: 'Indonesia',
		phone: '62',
		pattern: /^[0-9]{10,13}$/,
		example: '81234567890',
		maxLength: 13,
	},
	{
		code: 'IE',
		label: 'Ireland',
		phone: '353',
		pattern: /^[0-9]{9}$/,
		example: '851234567',
		maxLength: 9,
	},
	{
		code: 'IL',
		label: 'Israel',
		phone: '972',
		pattern: /^[0-9]{9}$/,
		example: '501234567',
		maxLength: 9,
	},
	{
		code: 'IM',
		label: 'Isle of Man',
		phone: '44',
		pattern: /^[0-9]{10}$/,
		example: '7924123456',
		maxLength: 10,
	},
	{
		code: 'IN',
		label: 'India',
		phone: '91',
		pattern: /^[0-9]{10}$/,
		example: '9876543***',
		maxLength: 10,
	},
	{
		code: 'IO',
		label: 'British Indian Ocean Territory',
		phone: '246',
		pattern: /^[0-9]{7}$/,
		example: '38012**',
		maxLength: 7,
	},
	{
		code: 'IQ',
		label: 'Iraq',
		phone: '964',
		pattern: /^[0-9]{10}$/,
		example: '79012345**',
		maxLength: 10,
	},
	{
		code: 'IR',
		label: 'Iran',
		phone: '98',
		pattern: /^[0-9]{10}$/,
		example: '91234567**',
		maxLength: 10,
	},
	{
		code: 'IS',
		label: 'Iceland',
		phone: '354',
		pattern: /^[0-9]{7}$/,
		example: '61234**',
		maxLength: 7,
	},
	{
		code: 'IT',
		label: 'Italy',
		phone: '39',
		pattern: /^[0-9]{10}$/,
		example: '33123456**',
		maxLength: 10,
	},
	{
		code: 'JE',
		label: 'Jersey',
		phone: '44',
		pattern: /^[0-9]{10}$/,
		example: '77971234**',
		maxLength: 10,
	},
	{
		code: 'JM',
		label: 'Jamaica',
		phone: '1-876',
		pattern: /^[0-9]{7}$/,
		example: '32112**',
		maxLength: 7,
	},
	{
		code: 'JO',
		label: 'Jordan',
		phone: '962',
		pattern: /^[0-9]{9}$/,
		example: '7901234**',
		maxLength: 9,
	},
	{
		code: 'JP',
		label: 'Japan',
		phone: '81',
		pattern: /^[0-9]{10}$/,
		example: '90123456**',
		maxLength: 10,
	},
	{
		code: 'KE',
		label: 'Kenya',
		phone: '254',
		pattern: /^[0-9]{9}$/,
		example: '7012345**',
		maxLength: 9,
	},
	{
		code: 'KG',
		label: 'Kyrgyzstan',
		phone: '996',
		pattern: /^[0-9]{9}$/,
		example: '7001234**',
		maxLength: 9,
	},
	{
		code: 'KH',
		label: 'Cambodia',
		phone: '855',
		pattern: /^[0-9]{9}$/,
		example: '9212345**',
		maxLength: 9,
	},
	{
		code: 'KI',
		label: 'Kiribati',
		phone: '686',
		pattern: /^[0-9]{5}$/,
		example: '901**',
		maxLength: 5,
	},
	{
		code: 'KM',
		label: 'Comoros',
		phone: '269',
		pattern: /^[0-9]{7}$/,
		example: '3211**',
		maxLength: 7,
	},
	{
		code: 'KN',
		label: 'Saint Kitts and Nevis',
		phone: '1-869',
		pattern: /^[0-9]{7}$/,
		example: '76612**',
		maxLength: 7,
	},
	{
		code: 'KP',
		label: 'North Korea',
		phone: '850',
		pattern: /^[0-9]{10}$/,
		example: '19212345**',
		maxLength: 10,
	},
	{
		code: 'KR',
		label: 'South Korea',
		phone: '82',
		pattern: /^[0-9]{10}$/,
		example: '10123456**',
		maxLength: 10,
	},
	{
		code: 'KW',
		label: 'Kuwait',
		phone: '965',
		pattern: /^[0-9]{8}$/,
		example: '600123**',
		maxLength: 8,
	},
	{
		code: 'KY',
		label: 'Cayman Islands',
		phone: '1-345',
		pattern: /^[0-9]{7}$/,
		example: '32312**',
		maxLength: 7,
	},
	{
		code: 'KZ',
		label: 'Kazakhstan',
		phone: '7',
		pattern: /^[0-9]{10}$/,
		example: '70123456**',
		maxLength: 10,
	},
	{
		code: 'LA',
		label: 'Laos',
		phone: '856',
		pattern: /^[0-9]{9}$/,
		example: '20231234**',
		maxLength: 9,
	},
	{
		code: 'LB',
		label: 'Lebanon',
		phone: '961',
		pattern: /^[0-9]{8}$/,
		example: '70123456',
		maxLength: 8,
	},
	{
		code: 'LC',
		label: 'Saint Lucia',
		phone: '1-758',
		pattern: /^[0-9]{7}$/,
		example: '2841234',
		maxLength: 7,
	},
	{
		code: 'LI',
		label: 'Liechtenstein',
		phone: '423',
		pattern: /^[0-9]{7}$/,
		example: '6601234',
		maxLength: 7,
	},
	{
		code: 'LK',
		label: 'Sri Lanka',
		phone: '94',
		pattern: /^[0-9]{9}$/,
		example: '711234567',
		maxLength: 9,
	},
	{
		code: 'LR',
		label: 'Liberia',
		phone: '231',
		pattern: /^[0-9]{8}$/,
		example: '77012345',
		maxLength: 8,
	},
	{
		code: 'LS',
		label: 'Lesotho',
		phone: '266',
		pattern: /^[0-9]{8}$/,
		example: '58881234',
		maxLength: 8,
	},
	{
		code: 'LT',
		label: 'Lithuania',
		phone: '370',
		pattern: /^[0-9]{8}$/,
		example: '61234567',
		maxLength: 8,
	},
	{
		code: 'LU',
		label: 'Luxembourg',
		phone: '352',
		pattern: /^[0-9]{9}$/,
		example: '621123456',
		maxLength: 9,
	},
	{
		code: 'LV',
		label: 'Latvia',
		phone: '371',
		pattern: /^[0-9]{8}$/,
		example: '21234567',
		maxLength: 8,
	},
	{
		code: 'LY',
		label: 'Libya',
		phone: '218',
		pattern: /^[0-9]{9}$/,
		example: '911234567',
		maxLength: 9,
	},
	{
		code: 'MA',
		label: 'Morocco',
		phone: '212',
		pattern: /^[0-9]{9}$/,
		example: '650123456',
		maxLength: 9,
	},
	{
		code: 'MC',
		label: 'Monaco',
		phone: '377',
		pattern: /^[0-9]{8}$/,
		example: '61234567',
		maxLength: 8,
	},
	{
		code: 'MD',
		label: 'Moldova',
		phone: '373',
		pattern: /^[0-9]{8}$/,
		example: '69123456',
		maxLength: 8,
	},
	{
		code: 'ME',
		label: 'Montenegro',
		phone: '382',
		pattern: /^[0-9]{8}$/,
		example: '67123456',
		maxLength: 8,
	},
	{
		code: 'MF',
		label: 'Saint Martin',
		phone: '590',
		pattern: /^[0-9]{9}$/,
		example: '690123456',
		maxLength: 9,
	},
	{
		code: 'MG',
		label: 'Madagascar',
		phone: '261',
		pattern: /^[0-9]{9}$/,
		example: '320123456',
		maxLength: 9,
	},
	{
		code: 'MH',
		label: 'Marshall Islands',
		phone: '692',
		pattern: /^[0-9]{7}$/,
		example: '2351234',
		maxLength: 7,
	},
	{
		code: 'MK',
		label: 'North Macedonia',
		phone: '389',
		pattern: /^[0-9]{8}$/,
		example: '70123456',
		maxLength: 8,
	},
	{
		code: 'ML',
		label: 'Mali',
		phone: '223',
		pattern: /^[0-9]{8}$/,
		example: '70123456',
		maxLength: 8,
	},
	{
		code: 'MM',
		label: 'Myanmar',
		phone: '95',
		pattern: /^[0-9]{9}$/,
		example: '9791234567',
		maxLength: 9,
	},
	{
		code: 'MN',
		label: 'Mongolia',
		phone: '976',
		pattern: /^[0-9]{8}$/,
		example: '99123456',
		maxLength: 8,
	},
	{
		code: 'MO',
		label: 'Macau',
		phone: '853',
		pattern: /^[0-9]{8}$/,
		example: '66123456',
		maxLength: 8,
	},
	{
		code: 'MP',
		label: 'Northern Mariana Islands',
		phone: '1-670',
		pattern: /^[0-9]{7}$/,
		example: '2341234',
		maxLength: 7,
	},
	{
		code: 'MQ',
		label: 'Martinique',
		phone: '596',
		pattern: /^[0-9]{9}$/,
		example: '696123456',
		maxLength: 9,
	},
	{
		code: 'MR',
		label: 'Mauritania',
		phone: '222',
		pattern: /^[0-9]{8}$/,
		example: '41123456',
		maxLength: 8,
	},
	{
		code: 'MS',
		label: 'Montserrat',
		phone: '1-664',
		pattern: /^[0-9]{7}$/,
		example: '4911234',
		maxLength: 7,
	},
	{
		code: 'MT',
		label: 'Malta',
		phone: '356',
		pattern: /^[0-9]{8}$/,
		example: '99123456',
		maxLength: 8,
	},
	{
		code: 'MU',
		label: 'Mauritius',
		phone: '230',
		pattern: /^[0-9]{8}$/,
		example: '52512345',
		maxLength: 8,
	},
	{
		code: 'MV',
		label: 'Maldives',
		phone: '960',
		pattern: /^[0-9]{7}$/,
		example: '7712345',
		maxLength: 7,
	},
	{
		code: 'MW',
		label: 'Malawi',
		phone: '265',
		pattern: /^[0-9]{9}$/,
		example: '991234567',
		maxLength: 9,
	},
	{
		code: 'MX',
		label: 'Mexico',
		phone: '52',
		pattern: /^[0-9]{10}$/,
		example: '5512345678',
		maxLength: 10,
	},
	{
		code: 'MY',
		label: 'Malaysia',
		phone: '60',
		pattern: /^[0-9]{9,10}$/,
		example: '123456789',
		maxLength: 10,
	},
	{
		code: 'MZ',
		label: 'Mozambique',
		phone: '258',
		pattern: /^[0-9]{9}$/,
		example: '821234567',
		maxLength: 9,
	},
	{
		code: 'NA',
		label: 'Namibia',
		phone: '264',
		pattern: /^[0-9]{10}$/,
		example: '8112345678',
		maxLength: 10,
	},
	{
		code: 'NC',
		label: 'New Caledonia',
		phone: '687',
		pattern: /^[0-9]{6}$/,
		example: '751234',
		maxLength: 6,
	},
	{
		code: 'NE',
		label: 'Niger',
		phone: '227',
		pattern: /^[0-9]{8}$/,
		example: '93123456',
		maxLength: 8,
	},
	{
		code: 'NF',
		label: 'Norfolk Island',
		phone: '672',
		pattern: /^[0-9]{6}$/,
		example: '361234',
		maxLength: 6,
	},
	{
		code: 'NG',
		label: 'Nigeria',
		phone: '234',
		pattern: /^[0-9]{10}$/,
		example: '8012345678',
		maxLength: 10,
	},
	{
		code: 'NI',
		label: 'Nicaragua',
		phone: '505',
		pattern: /^[0-9]{8}$/,
		example: '81234567',
		maxLength: 8,
	},
	{
		code: 'NL',
		label: 'Netherlands',
		phone: '31',
		pattern: /^[0-9]{9}$/,
		example: '612345678',
		maxLength: 9,
	},
	{
		code: 'NO',
		label: 'Norway',
		phone: '47',
		pattern: /^[0-9]{8}$/,
		example: '41234567',
		maxLength: 8,
	},
	{
		code: 'NP',
		label: 'Nepal',
		phone: '977',
		pattern: /^[0-9]{10}$/,
		example: '9801234567',
		maxLength: 10,
	},
	{
		code: 'NR',
		label: 'Nauru',
		phone: '674',
		pattern: /^[0-9]{7}$/,
		example: '5551234',
		maxLength: 7,
	},
	{
		code: 'NU',
		label: 'Niue',
		phone: '683',
		pattern: /^[0-9]{4}$/,
		example: '1234',
		maxLength: 4,
	},
	{
		code: 'NZ',
		label: 'New Zealand',
		phone: '64',
		pattern: /^[0-9]{9}$/,
		example: '211234567',
		maxLength: 9,
	},
	{
		code: 'OM',
		label: 'Oman',
		phone: '968',
		pattern: /^[0-9]{8}$/,
		example: '92123456',
		maxLength: 8,
	},
	{
		code: 'PA',
		label: 'Panama',
		phone: '507',
		pattern: /^[0-9]{7}$/,
		example: '61234567',
		maxLength: 7,
	},
	{
		code: 'PE',
		label: 'Peru',
		phone: '51',
		pattern: /^[0-9]{9}$/,
		example: '912345678',
		maxLength: 9,
	},
	{
		code: 'PF',
		label: 'French Polynesia',
		phone: '689',
		pattern: /^[0-9]{6}$/,
		example: '871234',
		maxLength: 6,
	},
	{
		code: 'PG',
		label: 'Papua New Guinea',
		phone: '675',
		pattern: /^[0-9]{7}$/,
		example: '71234567',
		maxLength: 7,
	},
	{
		code: 'PH',
		label: 'Philippines',
		phone: '63',
		pattern: /^[0-9]{10}$/,
		example: '9123456789',
		maxLength: 10,
	},
	{
		code: 'PK',
		label: 'Pakistan',
		phone: '92',
		pattern: /^[0-9]{10}$/,
		example: '3012345678',
		maxLength: 10,
	},
	{
		code: 'PL',
		label: 'Poland',
		phone: '48',
		pattern: /^[0-9]{9}$/,
		example: '501234567',
		maxLength: 9,
	},
	{
		code: 'PM',
		label: 'Saint Pierre and Miquelon',
		phone: '508',
		pattern: /^[0-9]{6}$/,
		example: '551234',
		maxLength: 6,
	},
	{
		code: 'PN',
		label: 'Pitcairn Islands',
		phone: '64',
		pattern: /^[0-9]{6}$/,
		example: '123456',
		maxLength: 6,
	},
	{
		code: 'PR',
		label: 'Puerto Rico',
		phone: '1',
		pattern: /^[0-9]{10}$/,
		example: '9391234567',
		maxLength: 10,
	},
	{
		code: 'PS',
		label: 'Palestine',
		phone: '970',
		pattern: /^[0-9]{9}$/,
		example: '599123456',
		maxLength: 9,
	},
	{
		code: 'PT',
		label: 'Portugal',
		phone: '351',
		pattern: /^[0-9]{9}$/,
		example: '912345678',
		maxLength: 9,
	},
	{
		code: 'PW',
		label: 'Palau',
		phone: '680',
		pattern: /^[0-9]{7}$/,
		example: '6201234',
		maxLength: 7,
	},
	{
		code: 'PY',
		label: 'Paraguay',
		phone: '595',
		pattern: /^[0-9]{9}$/,
		example: '971123456',
		maxLength: 9,
	},
	{
		code: 'QA',
		label: 'Qatar',
		phone: '974',
		pattern: /^[0-9]{8}$/,
		example: '33123456',
		maxLength: 8,
	},
	{
		code: 'RE',
		label: 'Réunion',
		phone: '262',
		pattern: /^[0-9]{9}$/,
		example: '692123456',
		maxLength: 9,
	},
	{
		code: 'RO',
		label: 'Romania',
		phone: '40',
		pattern: /^[0-9]{9}$/,
		example: '721234567',
		maxLength: 9,
	},
	{
		code: 'RS',
		label: 'Serbia',
		phone: '381',
		pattern: /^[0-9]{9}$/,
		example: '601234567',
		maxLength: 9,
	},
	{
		code: 'RU',
		label: 'Russia',
		phone: '7',
		pattern: /^[0-9]{10}$/,
		example: '9123456789',
		maxLength: 10,
	},
	{
		code: 'RW',
		label: 'Rwanda',
		phone: '250',
		pattern: /^[0-9]{9}$/,
		example: '781234567',
		maxLength: 9,
	},
	{
		code: 'SA',
		label: 'Saudi Arabia',
		phone: '966',
		pattern: /^[0-9]{9}$/,
		example: '501234567',
		maxLength: 9,
	},
	{
		code: 'SB',
		label: 'Solomon Islands',
		phone: '677',
		pattern: /^[0-9]{7}$/,
		example: '7421234',
		maxLength: 7,
	},
	{
		code: 'SC',
		label: 'Seychelles',
		phone: '248',
		pattern: /^[0-9]{7}$/,
		example: '2512345',
		maxLength: 7,
	},
	{
		code: 'SD',
		label: 'Sudan',
		phone: '249',
		pattern: /^[0-9]{9}$/,
		example: '911234567',
		maxLength: 9,
	},
	{
		code: 'SE',
		label: 'Sweden',
		phone: '46',
		pattern: /^[0-9]{9}$/,
		example: '701234567',
		maxLength: 9,
	},
	{
		code: 'SG',
		label: 'Singapore',
		phone: '65',
		pattern: /^[0-9]{8}$/,
		example: '81234567',
		maxLength: 8,
	},
	{
		code: 'SH',
		label: 'Saint Helena',
		phone: '290',
		pattern: /^[0-9]{4}$/,
		example: '6123',
		maxLength: 4,
	},
	{
		code: 'SI',
		label: 'Slovenia',
		phone: '386',
		pattern: /^[0-9]{8}$/,
		example: '40123456',
		maxLength: 8,
	},
	{
		code: 'SJ',
		label: 'Svalbard and Jan Mayen',
		phone: '47',
		pattern: /^[0-9]{8}$/,
		example: '91234567',
		maxLength: 8,
	},
	{
		code: 'SK',
		label: 'Slovakia',
		phone: '421',
		pattern: /^[0-9]{9}$/,
		example: '901234567',
		maxLength: 9,
	},
	{
		code: 'SL',
		label: 'Sierra Leone',
		phone: '232',
		pattern: /^[0-9]{8}$/,
		example: '76123456',
		maxLength: 8,
	},
	{
		code: 'SM',
		label: 'San Marino',
		phone: '378',
		pattern: /^[0-9]{10}$/,
		example: '6612345678',
		maxLength: 10,
	},
	{
		code: 'SN',
		label: 'Senegal',
		phone: '221',
		pattern: /^[0-9]{9}$/,
		example: '771234567',
		maxLength: 9,
	},
	{
		code: 'SO',
		label: 'Somalia',
		phone: '252',
		pattern: /^[0-9]{9}$/,
		example: '615123456',
		maxLength: 9,
	},
	{
		code: 'SR',
		label: 'Suriname',
		phone: '597',
		pattern: /^[0-9]{7}$/,
		example: '7412345',
		maxLength: 7,
	},
	{
		code: 'SS',
		label: 'South Sudan',
		phone: '211',
		pattern: /^[0-9]{9}$/,
		example: '912345678',
		maxLength: 9,
	},
	{
		code: 'ST',
		label: 'São Tomé and Príncipe',
		phone: '239',
		pattern: /^[0-9]{7}$/,
		example: '9812345',
		maxLength: 7,
	},
	{
		code: 'SV',
		label: 'El Salvador',
		phone: '503',
		pattern: /^[0-9]{8}$/,
		example: '70123456',
		maxLength: 8,
	},
	{
		code: 'SX',
		label: 'Sint Maarten',
		phone: '1-721',
		pattern: /^[0-9]{7}$/,
		example: '5201234',
		maxLength: 7,
	},
	{
		code: 'SY',
		label: 'Syria',
		phone: '963',
		pattern: /^[0-9]{9}$/,
		example: '944123456',
		maxLength: 9,
	},
	{
		code: 'SZ',
		label: 'Eswatini',
		phone: '268',
		pattern: /^[0-9]{8}$/,
		example: '76123456',
		maxLength: 8,
	},
	{
		code: 'TC',
		label: 'Turks and Caicos Islands',
		phone: '1-649',
		pattern: /^[0-9]{7}$/,
		example: '2311234',
		maxLength: 7,
	},
	{
		code: 'TD',
		label: 'Chad',
		phone: '235',
		pattern: /^[0-9]{8}$/,
		example: '63012345',
		maxLength: 8,
	},
	{
		code: 'TG',
		label: 'Togo',
		phone: '228',
		pattern: /^[0-9]{8}$/,
		example: '90123456',
		maxLength: 8,
	},
	{
		code: 'TH',
		label: 'Thailand',
		phone: '66',
		pattern: /^[0-9]{9}$/,
		example: '812345678',
		maxLength: 9,
	},
	{
		code: 'TJ',
		label: 'Tajikistan',
		phone: '992',
		pattern: /^[0-9]{9}$/,
		example: '901234567',
		maxLength: 9,
	},
	{
		code: 'TK',
		label: 'Tokelau',
		phone: '690',
		pattern: /^[0-9]{4}$/,
		example: '1234',
		maxLength: 4,
	},
	{
		code: 'TL',
		label: 'Timor-Leste',
		phone: '670',
		pattern: /^[0-9]{7}$/,
		example: '77123456',
		maxLength: 7,
	},
	{
		code: 'TM',
		label: 'Turkmenistan',
		phone: '993',
		pattern: /^[0-9]{8}$/,
		example: '65123456',
		maxLength: 8,
	},
	{
		code: 'TN',
		label: 'Tunisia',
		phone: '216',
		pattern: /^[0-9]{8}$/,
		example: '20123456',
		maxLength: 8,
	},
	{
		code: 'TO',
		label: 'Tonga',
		phone: '676',
		pattern: /^[0-9]{7}$/,
		example: '7712345',
		maxLength: 7,
	},
	{
		code: 'TR',
		label: 'Turkey',
		phone: '90',
		pattern: /^[0-9]{10}$/,
		example: '5301234567',
		maxLength: 10,
	},
	{
		code: 'TT',
		label: 'Trinidad and Tobago',
		phone: '1-868',
		pattern: /^[0-9]{7}$/,
		example: '2911234',
		maxLength: 7,
	},
	{
		code: 'TV',
		label: 'Tuvalu',
		phone: '688',
		pattern: /^[0-9]{5}$/,
		example: '90123',
		maxLength: 5,
	},
	{
		code: 'TW',
		label: 'Taiwan',
		phone: '886',
		pattern: /^[0-9]{9}$/,
		example: '912345678',
		maxLength: 9,
	},
	{
		code: 'TZ',
		label: 'Tanzania',
		phone: '255',
		pattern: /^[0-9]{9}$/,
		example: '712345678',
		maxLength: 9,
	},
	{
		code: 'UA',
		label: 'Ukraine',
		phone: '380',
		pattern: /^[0-9]{9}$/,
		example: '671234567',
		maxLength: 9,
	},
	{
		code: 'UG',
		label: 'Uganda',
		phone: '256',
		pattern: /^[0-9]{9}$/,
		example: '771234567',
		maxLength: 9,
	},
	{
		code: 'US',
		label: 'United States',
		phone: '1',
		pattern: /^[0-9]{10}$/,
		example: '2021234567',
		maxLength: 10,
	},
	{
		code: 'UY',
		label: 'Uruguay',
		phone: '598',
		pattern: /^[0-9]{8}$/,
		example: '99123456',
		maxLength: 8,
	},
	{
		code: 'UZ',
		label: 'Uzbekistan',
		phone: '998',
		pattern: /^[0-9]{9}$/,
		example: '901234567',
		maxLength: 9,
	},
	{
		code: 'VA',
		label: 'Vatican City',
		phone: '379',
		pattern: /^[0-9]{8}$/,
		example: '66981234',
		maxLength: 8,
	},
	{
		code: 'VC',
		label: 'Saint Vincent and the Grenadines',
		phone: '1-784',
		pattern: /^[0-9]{7}$/,
		example: '4301234',
		maxLength: 7,
	},
	{
		code: 'VE',
		label: 'Venezuela',
		phone: '58',
		pattern: /^[0-9]{10}$/,
		example: '4121234567',
		maxLength: 10,
	},
	{
		code: 'VG',
		label: 'British Virgin Islands',
		phone: '1-284',
		pattern: /^[0-9]{7}$/,
		example: '3001234',
		maxLength: 7,
	},
	{
		code: 'VI',
		label: 'United States Virgin Islands',
		phone: '1-340',
		pattern: /^[0-9]{7}$/,
		example: '2271234',
		maxLength: 7,
	},
	{
		code: 'VN',
		label: 'Vietnam',
		phone: '84',
		pattern: /^[0-9]{9,10}$/,
		example: '901234567',
		maxLength: 10,
	},
	{
		code: 'VU',
		label: 'Vanuatu',
		phone: '678',
		pattern: /^[0-9]{7}$/,
		example: '7712345',
		maxLength: 7,
	},
	{
		code: 'WF',
		label: 'Wallis and Futuna',
		phone: '681',
		pattern: /^[0-9]{6}$/,
		example: '501234',
		maxLength: 6,
	},
	{
		code: 'WS',
		label: 'Samoa',
		phone: '685',
		pattern: /^[0-9]{7}$/,
		example: '7212345',
		maxLength: 7,
	},
	{
		code: 'XK',
		label: 'Kosovo',
		phone: '383',
		pattern: /^[0-9]{8}$/,
		example: '44123456',
		maxLength: 8,
	},
	{
		code: 'YE',
		label: 'Yemen',
		phone: '967',
		pattern: /^[0-9]{9}$/,
		example: '712345678',
		maxLength: 9,
	},
	{
		code: 'YT',
		label: 'Mayotte',
		phone: '262',
		pattern: /^[0-9]{9}$/,
		example: '639123456',
		maxLength: 9,
	},
	{
		code: 'ZA',
		label: 'South Africa',
		phone: '27',
		pattern: /^[0-9]{9}$/,
		example: '721234567',
		maxLength: 9,
	},
	{
		code: 'ZM',
		label: 'Zambia',
		phone: '260',
		pattern: /^[0-9]{9}$/,
		example: '961234567',
		maxLength: 9,
	},
	{
		code: 'ZW',
		label: 'Zimbabwe',
		phone: '263',
		pattern: /^[0-9]{9}$/,
		example: '771234567',
		maxLength: 9,
	},
];
